// Minimal `moment`-compatible shim used only for the small set of format
// strings invoked by ported admin components. Implements just enough of the
// `moment(value).format(pattern)` API surface to keep those call sites working
// without pulling in the full `moment` package.
//
// Supported tokens: YYYY, YY, MMMM, MMM, MM, M, DD, D, dddd, ddd, HH, H, hh,
// h, mm, m, ss, s, SSS, A, a.

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const DAYS = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];

const pad = (n, w = 2) => String(n).padStart(w, "0");

function format(date, pattern) {
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const dow = date.getDay();
  const hours24 = date.getHours();
  const hours12 = ((hours24 + 11) % 12) + 1;
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ms = date.getMilliseconds();
  const isPm = hours24 >= 12;

  const replacers = [
    ["YYYY", String(year)],
    ["YY", String(year).slice(-2)],
    ["MMMM", MONTHS[month]],
    ["MMM", MONTHS[month].slice(0, 3)],
    ["MM", pad(month + 1)],
    ["M", String(month + 1)],
    ["DD", pad(day)],
    ["D", String(day)],
    ["dddd", DAYS[dow]],
    ["ddd", DAYS[dow].slice(0, 3)],
    ["HH", pad(hours24)],
    ["H", String(hours24)],
    ["hh", pad(hours12)],
    ["h", String(hours12)],
    ["mm", pad(minutes)],
    ["m", String(minutes)],
    ["ss", pad(seconds)],
    ["s", String(seconds)],
    ["SSS", pad(ms, 3)],
    ["A", isPm ? "PM" : "AM"],
    ["a", isPm ? "pm" : "am"],
  ];

  // Tokenize: longer tokens first so MMMM consumes before MMM, etc.
  let out = "";
  let i = 0;
  while (i < pattern.length) {
    let matched = false;
    for (const [token, value] of replacers) {
      if (pattern.startsWith(token, i)) {
        out += value;
        i += token.length;
        matched = true;
        break;
      }
    }
    if (!matched) {
      out += pattern[i];
      i += 1;
    }
  }
  return out;
}

function moment(value) {
  const date = value instanceof Date ? value : new Date(value);
  return {
    format: (pattern) => format(date, pattern),
    toDate: () => date,
    isValid: () => !Number.isNaN(date.getTime()),
  };
}

export default moment;
